import React from "react";
import get from "lodash/get";
import { object, shape } from "prop-types";

import HeroCarousel from "../molecules/hero-carousel";
import { StatsSection } from "../molecules/stats-section";
import { CXONetworkSection } from "../molecules/cxo-network-section";
import { TwoColumnTextSection } from "../molecules/two-column-text-section";
import { EventsSection } from "../molecules/events-section";
import { ResearchHubSection } from "../molecules/research-hub-section";
import { StrategicOfferingsSection } from "../molecules/strategic-offerings-section";
import { ExpertSpeaksSection } from "../molecules/expert-speaks-section";
import { ContactFormSection } from "../molecules/contact-form-section";

import "./home.m.css";

export const HomePage = (props) => {
  const collection = get(props, 'data.collection', {});
  return (
    <div styleName="home-page">
      <HeroCarousel collection={collection} />
      <StatsSection />
      <CXONetworkSection />
      <TwoColumnTextSection />
      <EventsSection />
      <ResearchHubSection />
      <StrategicOfferingsSection />
      <ExpertSpeaksSection collection={collection} />
      <ContactFormSection />
    </div>
  );
};

HomePage.propTypes = {
  data: shape({
    collection: object,
  }),
};